import React from 'react';

export default function YearView({ date, onSelectMonth }: { date: Date; onSelectMonth: (monthIndex: number) => void; }) {
    const months = Array.from({ length: 12 }, (_, i) => new Date(date.getFullYear(), i, 1));
    return (
        <div className="w-full bg-gray-900 border border-gray-800 rounded-lg p-3">
            <div className="text-white font-semibold mb-3">{date.getFullYear()}</div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                {months.map((m, idx) => (
                    <button key={idx} className="p-4 rounded-lg bg-gray-800 border border-gray-700 text-gray-200 hover:bg-gray-700 text-left" onClick={() => onSelectMonth(idx)}>
                        {m.toLocaleDateString('en-US', { month: 'long' })}
                    </button>
                ))}
            </div>
        </div>
    );
}
